import React from "react";
import { Link } from "react-router-dom";
import { PrintStoreImages } from "../galleryImages";
import "./Prints.css";

export default function Prints() {
  return (
    <main className="prints-page">
      <header className="prints-header">
        <div className="prints-header-title">
          <h1>PRINTS</h1>
        </div>

        <div className="prints-header-meta">
          <p>Selected photographs available as archival fine-art prints.</p>
        </div>
      </header>

      <section className="prints-collection">
        <div className="prints-collection-top">
          <span>AVAILABLE PRINTS</span>
          <span>( {PrintStoreImages.length} )</span>
        </div>

        <div className="prints-grid">
          {PrintStoreImages.map((image) => {
            const prices = Object.values(image.print.sizes);
            const startingPrice = Math.min(...prices);

            return (
              <Link
                key={image.id}
                to={`/prints/${image.id}`}
                className="print-card"
              >
                <div className="print-card-image">
                  <img
                    src={image.photo}
                    alt={image.title || "Octavio Garcia photograph"}
                    draggable="false"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>

                <div className="print-card-details">
                  <div className="print-card-name">
                    <span>{image.title || "Untitled"}</span>
                  </div>

                  <span className="print-card-price">
                    FROM ${startingPrice.toLocaleString()}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <footer className="prints-footer">
        <span>TERMS OF USE / PRIVACY</span>
        <Link to="/prints/information">PRINT INFORMATION →</Link>
      </footer>
    </main>
  );
}
